<!--最多支持两级的多选组件-->
<template>
	<ul class="list-body custom-scrollbar">
		<template v-for="item in dataList">
			<li v-if="getNextMethod(item) != undefined">
				<div class="flexStart" @click="$set(openUl,getIdMethod(item),openUl[getIdMethod(item)] == true?false:true)" style="cursor: pointer;">
					<img class="icon" :src="getIcon(item)" v-show="item.next.length != 0">
					<img src="../../../../assets/show.png" alt="" v-show="item.next.length == 0">
					<!-- <img class="icon" :src="getCheckIcon(item)" @click.stop="selectionType == 'singleGroup'?checkItem(item):checkGroup(item)" v-if="selectionType != 'singleItem'"> -->
					<img class="icon" :src="getCheckIcon(item)" @click.stop="selectionType == 'singleGroup'?checkItem(item):checkGroup(item)" v-if="selectionType != 'singleItem'">
					 <table class="tree-table">
						<tr>
							<!-- （{{idToCheckedCount[getIdMethod(item)]}}/{{idToCheckAbleCount[getIdMethod(item)]}}） -->
							<td class="td1"><p class="nameItem">{{item.name}}</p> </td>
							<td class="td2"> <p> {{item.iconFile}}</p> </td>
							<td class="td3"> <p> {{item.webpage}}</p> </td>
							<td class="td4"> <p> {{item.memo}}</p> </td>
						</tr>
					 </table>
					
				</div>
				<roleMultipleSelection :ref="getIdMethod(item)+'next'" style="margin-left: 14px;border: 0;height: auto;" v-show="openUl[getIdMethod(item)] == true"
				 :dataList="getNextMethod(item)" :getIdMethod="getIdMethod" :getNextMethod="getNextMethod" :defaultCheckedIds="defaultCheckedIds" 
				 :editDisableList="editDisableList" :nowSelectIds="nowSelectIds" :idToCheckAbleCount="idToCheckAbleCount" :idToCheckedCount="idToCheckedCount" :isSon="true"
				 :selectionType="selectionType" @checkItem="nextCheckItem($event,item)" @unCheckItem="nextUnCheckItem($event,item)"></roleMultipleSelection>
			</li>
			<li v-else style="cursor: pointer;" class="flexStart" @click="checkItem(item)">
				<img class="icon" :src="getCheckIcon(item)">56416516
				<p class="nameItem">{{item.name}}</p>
			</li>
		</template>
	</ul>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		name: 'roleMultipleSelection',
		components: {},
		props: {
			selectionType: {
				validator(value) {
					return ['singleGroup', 'singleItem', 'multiple'].includes(value)
				},
				type: String,
				default: 'singleItem'
			},
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			getIdMethod: {
				type: Function,
				default (item) {
					return item.id
				}
			},
			getNextMethod: {
				type: Function,
				default (item) {
					//返回undefined则是最终级，不会出现展开图标
					if(item.hasOwnProperty('next')){
						return item.next
					}else{
						return undefined
					}
				}
			},
			defaultCheckedIds: {
				type: Array,
				default () {
					return []
				}
			},
			nowSelectIds: {
				type: Object,
				default () {
					return {}
				}
			},
			idToCheckAbleCount: {
				type: Object,
				default () {
					return {}
				}
			},
			idToCheckedCount: {
				type: Object,
				default () {
					return {}
				}
			},
			isSon: {
				//判断是否非第一级的组件，用于刷新总数
				type: Boolean,
				default: false
			},
			editDisableList: {
				type: Array,
				default(){
					return []
				}
			}
		},
		data() {
			return {
				openUl: {},
			}
		},
		created() {},
		mounted() {
			if (!this.isSon) {
				this.setNowCheckedIds(this.defaultCheckedIds)
				this.refreshCheckAbleCount(this.dataList)
				this.refreshCheckedCount(this.dataList)
				//打开第一个列表(如果是列表)
				// console.log("dataList",this.dataList);
				if (this.dataList[0]!=undefined && this.getNextMethod(this.dataList[0]) != undefined) {
					this.$set(this.openUl,this.getIdMethod(this.dataList[0]),true)
				}
			}
		},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return resourcesStore.getters.getBackgroudImageStyle
			},
			getBackgroudColorStyle() {
				return resourcesStore.getters.getBackgroudColorStyle
			},
			getResourcesByName() {
				return resourcesStore.getters.getResourcesByName
			},
			getColorById() {
				return resourcesStore.getters.getColorById
			},
			getColorStyleById() {
				return resourcesStore.getters.getColorStyleById
			},
			getIcon() {
				return item => {
					return resourcesStore.getters.getResourcesByName('/MultipleSelection/' + (this.openUl[this.getIdMethod(item)] ==
							true ? 'icon_down.png' : 'icon_up.png'))
				}
			},
			getCheckIcon() {
				return nItem => {
					// console.log("editDisableList",this.editDisableList);
				//   console.log("nItem.id",nItem.id);
				// console.log("this.nowSelectIds",this.nowSelectIds);
						return resourcesStore.getters.getResourcesByName('/checkBox/' + (this.nowSelectIds[this.getIdMethod(nItem)] ==
							true ? 'icon_checked.png' : 'icon_uncheck.png'))
					// if(this.editDisableList.indexOf(nItem.id) > -1){
					// 	// console.log(1);
					// 	return resourcesStore.getters.getResourcesByName('/checkBox/' + (this.nowSelectIds[this.getIdMethod(nItem)] ==
					// 		true ? 'icon_disabled_checked.png' : 'icon_disabled_uncheck.png'))
						
					// }else{
					// 	// console.log(2);
					// 	return resourcesStore.getters.getResourcesByName('/checkBox/' + (this.nowSelectIds[this.getIdMethod(nItem)] ==
					// 		true ? 'icon_checked.png' : 'icon_uncheck.png'))
					// }
				}
			},
		},
		watch: {
			defaultCheckedIds(nv, ov) {
				if (!this.isSon) {
					this.setNowCheckedIds(nv)
				}
			},
			dataList(nv, ov) {
				if (!this.isSon) {
					this.refreshCheckAbleCount(nv)
					if (nv[0]!=undefined && this.getNextMethod(nv[0]) != undefined) {
						this.$set(this.openUl,this.getIdMethod(nv[0]),true)
					}
				}
			},
			nowSelectIds(nv, ov) {
				if (!this.isSon) {
					this.refreshCheckedCount(this.dataList)
				}
			}
		},
		methods: {
			getNowCheckList() {
				//取出所有被选中的对象列表,由外部调用
				var idList = []
				eachObject(this.nowSelectIds, (value, id) => {
					if (value == true) {
						idList.push(id)
					}
				})
				//递归从数据列中获取所有选中的id的对象
				var resultList = []
				for (var i = 0, len = this.dataList.length; i < len; i++) {
					var item = this.dataList[i]
					if (idList.includes(this.getIdMethod(item))) {
						resultList.push(item)
					}
					//获取下一级的
					var nextBean = this.$refs[this.getIdMethod(item) + 'next']
					if (nextBean != undefined && nextBean[0] != undefined) {
						resultList.addAll(nextBean[0].getNowCheckList())
					}
				}
				return resultList
			},
			setNowCheckedIds(ids) {
				// console.log("kjikjn",ids);
				//先移除所有选中
				eachObject(this.nowSelectIds, (item, key) => {
					this.$delete(this.nowSelectIds, key)
				})
				if (ids != undefined) {
					for (var i = 0, len = ids.length; i < len; i++) {
						var item = ids[i]
						this.$set(this.nowSelectIds, item, true)
					}
				}
			},
			setEditDisableList(list) {
				for(let i = this.editDisableList.length;i >= 0;i--){
					this.$delete(this.editDisableList, i)
				}
				for(let i = 0;i < list.length;i++){
					this.$set(this.editDisableList, i, list[i])
				}
			},
			checkItem(item) {
				console.log("item",item);
				if(!isempty(this.editDisableList) && this.editDisableList.indexOf(item.id) > -1){
					return
				}
				if (this.nowSelectIds[this.getIdMethod(item)] == true) {
					this.$delete(this.nowSelectIds, this.getIdMethod(item))
					if (this.selectionType == 'multiple') {
						this.$emit('unCheckItem', item)
					}
				} else {
					if (this.selectionType != 'multiple') {
						//单选时取消其他选中
						eachObject(this.nowSelectIds, (item, key) => {
							this.$delete(this.nowSelectIds, key)
						})
					}
					this.$set(this.nowSelectIds, this.getIdMethod(item), true)
					if (this.selectionType == 'multiple') {
						this.$emit('checkItem', item)
					}
				}
			},
			checkGroup(group) {
				// if(!isempty(this.editDisableList) && this.editDisableList.indexOf(group.id) > -1){
				// 	return
				// }

				// console.log("勾选12134",group);

				
				var checkAll = (list,value) => {
					for (var i = 0, len = list.length; i < len; i++) {
						var item = list[i]
						var next = this.getNextMethod(item)
						if (next != undefined) {
							checkAll(next, value)
						}
						this.$set(this.nowSelectIds, this.getIdMethod(item), value)
					}
				}
				// console.log("this.selectionType",this.selectionType);
				//选中了组
				switch (this.selectionType) {
					case 'singleGroup':
						eachObject(this.nowSelectIds, (group, key) => {
							this.$delete(this.nowSelectIds, key)
						})
						
						this.$set(this.nowSelectIds, this.getIdMethod(group), true)
						break
					case 'multiple':
						if (this.nowSelectIds[this.getIdMethod(group)] == true) {
							//取消本级和所有下级的选中
							console.log("取消全部选中",group);
							this.$set(this.nowSelectIds, this.getIdMethod(group), false)
							checkAll(this.getNextMethod(group),false)
							this.$emit('unCheckItem', group)
						} else {
							//选中本级别和所有下级
							this.$set(this.nowSelectIds, this.getIdMethod(group), true)
							checkAll(this.getNextMethod(group),true)
							this.$emit('checkItem', group)
						}
						break
				}
			},
			refreshCheckAbleCount(list) {
				for (var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					this.getCheckAbleCount(item)
				}
			},
			getCheckAbleCount(data) {
				var id = this.getIdMethod(data)
				var next = this.getNextMethod(data)
				if (next == undefined || next.length == 0) {
					this.$set(this.idToCheckAbleCount, id, 0)
					return 0
				}
				var count = 0
				for (var i = 0, len = next.length; i < len; i++) {
					var item = next[i]
					if (this.getNextMethod(item) == undefined) {
						count++
					} else {
						count += this.getCheckAbleCount(item)
						if (this.selectionType == 'singleGroup') {
							count++
						}
					}
				}
				this.$set(this.idToCheckAbleCount, id, count)
				return count
			},
			refreshCheckedCount(list) {
				for (var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					this.getCheckedCount(item)
				}
			},
			getCheckedCount(data) {
				var id = this.getIdMethod(data)
				var next = this.getNextMethod(data)
				if (next == undefined || next.length == 0) {
					this.$set(this.idToCheckedCount, id, 0)
					return 0
				}
				var count = 0
				for (var i = 0, len = next.length; i < len; i++) {
					var item = next[i]
					if (this.getNextMethod(item) == undefined) {
						if (this.nowSelectIds[this.getIdMethod(item)] == true) {
							count++
						}
					} else {
						if (this.selectionType == 'singleGroup' && this.nowSelectIds[this.getIdMethod(item)] == true) {
							count++
						}
						count += this.getCheckedCount(item)
					}
				}
				this.$set(this.idToCheckedCount, id, count)
				return count
			},
			nextCheckItem(item, group) {
				//下级选中了某个项
				//如果下级全选中了，本级别也选中
				// if (this.getNextMethod(group).find(i => this.nowSelectIds[this.getIdMethod(i)] != true) == undefined) {
					this.$set(this.nowSelectIds, this.getIdMethod(group), true)
					// console.log("选中",group);
					this.$emit('checkItem', group)
				// }
			},
			nextUnCheckItem(item, group) {
				this.$set(this.nowSelectIds, this.getIdMethod(group), false)
				this.$emit('unCheckItem', group)
			}

		}
	}
</script>

<style scoped>
	.list-body {
		background: white;
		border: silver 1px solid;
		border-radius: 5px;
		overflow-y: auto;
		height: 700px;
	}

	.nameItem {
		padding: 8px 0;
	}

	.list-body>li {
		padding: 0 8px;
		/* border-bottom: 1px silver dashed; */
		border-bottom: 1px solid #e6e6e6;
	}

	.list-body>li:last-child {
		border: 0;
	}

	.icon {
		width: 15px;
		height: 15px;
		margin-right: 5px;
	}


.list-body  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-spacing: 0;
}

.list-body  table td {
    word-break: break-all;
    word-wrap: break-word;
    font-size: 14px;
    font-weight: 600;
}
  th,
  td {
    text-align: left;
}
  .tree-table .td1 {
    width: 16%;
    padding-left: 2%;
}
.tree-table .td2 {
    width: 17%;
}
.tree-table .td3 {
    width: 18%;
}
.tree-table .td4 {
    width: 29%;
}
</style>
